import { getItemWebStorage } from '../../../../../features/webStorageSaver'
import { store } from '../../../../../stateManagement/store'
import type { SpecialContributor } from '../types'

export const signRoadImageContributor: SpecialContributor = {
    id: 'signRoadImage',
    useContribute: ({ objectId }) => {
        const token = (store as any).getState().auth.tokens.app
        const currentApiUrl = getItemWebStorage('currentApiUrl')

        if (!token || !currentApiUrl || !objectId) return {}

        return {
            computedFields: {
                SignRoadImage: {
                    isLoading: false,
                    value: { type: 'image', url: `${currentApiUrl}/objects/roadSignImage?Token='${token}'&Id=${objectId}&Width=300&Height=300`, alt: 'Отсутствует изображение' }
                }
            }
        }
    }
}


